import * as React from 'react';
import { IMedia, IProduct } from '../types';
import { Config } from '../types/config';
import CartConfirmation
  from '../components/PostViewer/components/Products/components/CartConfirmation';

interface ConfirmationState {
  product: IProduct;
  media: IMedia;
}

/**
 * Renders the cart confirmation screen — either the built-in `<CartConfirmation />`
 * or the client-supplied `displayCustomCartConfirmation` custom renderer.
 *
 * Returns `null` when `confirmedProduct` is falsy.
 */
// eslint-disable-next-line import/prefer-default-export
export function renderCartConfirmation(
  confirmedProduct: ConfirmationState | null,
  config: Config,
  isMobile: boolean,
  cornerType: 'rounded' | 'square',
  onContinue: () => void,
): React.ReactNode | null {
  if (!confirmedProduct) return null;

  const customRenderer = config.displayCustomCartConfirmation;
  if (customRenderer) {
    return customRenderer({
      react: React,
      product: confirmedProduct.product,
      media: confirmedProduct.media,
      onContinue,
      isMobile,
    });
  }

  return (
    <CartConfirmation
      product={confirmedProduct.product}
      isMobile={isMobile}
      cartUrl={config.cartUrl}
      cornerType={cornerType}
      onContinue={onContinue}
    />
  );
}
